import { Box, Modal } from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import UploadIcon from '@mui/icons-material/Upload';
import { Button, CircularProgress } from "@mui/joy";
import { set } from "lodash";
import ImageViewer from "../../../../../mobile/etc/imageviewer/imageviewer";
import { postFetch } from "../../../../../fetch/fetch";

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    height: 600,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const ImageUploadModalForCoaching = (props: any) => {

    const [isExist, setIsExist] = useState(false);
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const [isDragOver, setIsDragOver] = useState(false);
    const [loading, setLoading] = useState(false);
    const [src, setSrc] = useState<string | null>(null);
    const [insertedId, setInsertedId] = useState<string | null>(null);
    const [viewerOpen, setViewerOpen] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);

    const viewerClose = () => {
        setViewerOpen(false);

    }

    useEffect(() => {

        if (props.open) {
            setSelectedFile(null);
            setIsDragOver(false);
            setLoading(false);
            setSrc(null);
            setInsertedId(null);
        }

    }, [props.open]);

    useEffect(() => {

        if (props.src) {
            setIsExist(true);
        } else {
            setIsExist(false);
        }

    }, []);



    //새로운 selectedFile이 들어올때마다 handleFileUpload을 실행한다.
    useEffect(() => {
        handleFileUpload();
    }, [selectedFile]);

    useEffect(() => {
        const handlePaste = (e: any) => {

            if (!props.open) {

                return;
            }

            const item = e.clipboardData?.items[0];
            if (item?.type.indexOf('image') === 0) {
                setSelectedFile(item.getAsFile());
            }
        }

        window.addEventListener('paste', handlePaste);
        return () => window.removeEventListener('paste', handlePaste);
    }, [props.open]);


    const handleFileUpload = async () => {

        if (!props.userId) {
            return;
        }

        if (!props.open) {
            return;
        }

        if (selectedFile) {

            //selectedFile이 이미지가 아닐 경우 return
            if (selectedFile.type.indexOf('image') === -1) {
                return;
            }

            setLoading(true);

            const formData = new FormData();
            formData.append('file', selectedFile);

            const message = {
                studentId: props.userId,
            }

            formData.append('message', JSON.stringify(message));


            try {

                const resposne = await fetch("https://peetsunbae.com/dashboard/mycoach/coachreport/img", {
                    method: "POST",
                    credentials: "include",
                    body: formData
                });

                const result = await resposne.json();


                if (result.message === "success") {
                    setLoading(false);
                    // props.success();
                    // props.handleClose();
                    // props.update();

                    const src = result.data.src;
                    console.log("src", src);
                    setSrc(src);
                    const insertedId = result.data.insertedId;
                    console.log("insertedId", insertedId);
                    setInsertedId(insertedId);
                }

            } catch (e) {

            }

            setLoading(false);

        }
    }

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedFile(e.target.files ? e.target.files[0] : null);
    }

    const handleFileDrop = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        if (e.dataTransfer.items) {
            if (e.dataTransfer.items[0].kind === 'file') {
                setSelectedFile(e.dataTransfer.items[0].getAsFile());
            }
        }
    }

    const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        setIsDragOver(true);
    }

    const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        setIsDragOver(false);
    }

    const submit = async () => {

        try{

            if (!insertedId) {
                return;
            }
            
            setSubmitLoading(true);

            const result : any = await postFetch("/dashboard/mycoach/coachreport/imgsubmit", {
                insertedId 
            });

           console.log("result", result);

            setSubmitLoading(false);

            if (result.message === "success") {
                props.success();
                props.handleClose();
                props.update();
            } else {
                console.error("Error submitting image:", result);
            }

        }catch(e){
            console.error("Error submitting image:", e);
        }

    }



    return (
        <Modal
            open={props.open}
            onClose={props.handleClose}

        >
            <Box sx={style}>
                <div style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}
                >
                    <div
                        style={{
                            flex: 1,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontSize: "24px",
                            fontFamily: "Apple_R"
                        }}
                    >
                        수업기록지 사진 업로드
                    </div>
                    <div
                        style={{
                            flex: 0.5,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontSize: "12px",
                            fontFamily: "Apple_L"
                        }}
                    >
                        (드래그 드롭, 복사 붙여넣기, 파일 선택)
                    </div>
                    {
                        !src
                            ?
                            <div
                                style={{
                                    flex: 5,
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    width : "100%"
                                }}
                                onDrop={handleFileDrop}
                                onDragOver={handleDragOver}
                                onDragLeave={handleDragLeave}
                            >
                                {
                                    !loading &&
                                    <>
                                        <UploadIcon style={{ fontSize: "64px", cursor: "pointer" }} onClick={() => fileInputRef.current?.click()} />
                                        <input type="file" accept="image/*" ref={fileInputRef} onChange={handleFileChange} style={{ display: "none" }} />
                                    </>
                                }
                                {
                                    loading &&
                                    <div style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                        <CircularProgress size="lg" />
                                    </div>
                                }
                            </div>
                            :
                            <div
                                style={{
                                    flex: 5,
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <img
                                    src={src}
                                    alt="Uploaded"
                                    style={{ width: "100%", height: "100%", objectFit: "contain", marginTop: "16px" }}
                                />
                            </div>
                    }

                    <div style={{ flex: 0.5 }}>

                    </div>

                    {
                        src &&
                        <div style={{
                            width : "100%"
                        }}>
                            <Button
                                variant="solid"
                                color="primary"
                                onClick={submit}
                                fullWidth
                                loading={submitLoading}
                            >
                                전송하기
                            </Button>
                        </div>
                    }
                </div>

            </Box>



        </Modal>
    )
}

export default ImageUploadModalForCoaching;